<template>
    <button
        type="button"
        class="service-favorite-star"
        :class="{ 'service-favorite-star_active': favorite }"
        :title="favorite ? 'Убрать из избранного' : 'Добавить в избранное'"
        :aria-label="favorite ? 'Убрать из избранного' : 'Добавить в избранное'"
        :aria-pressed="String(favorite)"
        :disabled="busy"
        @mousedown.stop.prevent
        @click.stop.prevent="$emit('toggle')"
        @keydown.enter.stop
        @keydown.space.stop
    >
        {{ favorite ? '★' : '☆' }}
    </button>
</template>
<script>
export default {
    props: {
        favorite: { type: Boolean, default: false },
        busy: { type: Boolean, default: false },
    },
};
</script>
<style lang="scss">
.service-favorite-star {
    flex: 0 0 32px;
    width: 32px;
    height: 32px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #777;
    font-size: 24px;
    line-height: 32px;
    cursor: pointer;
    &_active {
        color: #d89400;
    }
    &:focus-visible {
        outline: 2px solid #268762;
        border-radius: 4px;
    }
    &:disabled {
        opacity: 0.5;
        cursor: wait;
    }
}
</style>
